module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"AI试穿照说明","description_title":"请上传试穿照","description_content":"上传照片后，AI将通过分析判断是否为试穿照。请上传穿着商品并露出身体部位（眼、鼻、嘴、手臂、腿、腰部等）的照片。","disclaimer":"*由 AI 分析模型判定，分析结果可能会有误差。"}}')
  delete Component.options._Ctor
}
